module.exports = {"StatusCode":200,"Payload":[{"stripeId":"some-stripe-id"}]}


//////////////////
// WEBPACK FOOTER
// ./src/payloads/aws/lambda/mocks/ownerFirstLogin.json
// module id = k3yL
// module chunks = 0